export default "__VITE_ASSET__DT6uN5Go__"